/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ checkIn: NonNullable<unknown>, checkOut: NonNullable<unknown> }} Seller_Orders_Rental_DatesInputs */

const en_seller_orders_rental_dates = /** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.checkIn} → ${i?.checkOut}`)
};

const es_seller_orders_rental_dates = /** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.checkIn} → ${i?.checkOut}`)
};

const fr_seller_orders_rental_dates = /** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.checkIn} → ${i?.checkOut}`)
};

const de_seller_orders_rental_dates = /** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.checkIn} → ${i?.checkOut}`)
};

const id_seller_orders_rental_dates = /** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.checkIn} → ${i?.checkOut}`)
};

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const ja_seller_orders_rental_dates = en_seller_orders_rental_dates;

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const zh_seller_orders_rental_dates = en_seller_orders_rental_dates;

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const ar_seller_orders_rental_dates = en_seller_orders_rental_dates;

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const it_seller_orders_rental_dates = en_seller_orders_rental_dates;

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const ru_seller_orders_rental_dates = en_seller_orders_rental_dates;

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const pt_seller_orders_rental_dates = en_seller_orders_rental_dates;

/** @type {(inputs: Seller_Orders_Rental_DatesInputs) => LocalizedString} */
const ko_seller_orders_rental_dates = en_seller_orders_rental_dates;

/**
* | output |
* | --- |
* | "{checkIn} → {checkOut}" |
*
* @param {Seller_Orders_Rental_DatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_orders_rental_dates = /** @type {((inputs: Seller_Orders_Rental_DatesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Orders_Rental_DatesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_orders_rental_dates(inputs)
	if (locale === "es") return es_seller_orders_rental_dates(inputs)
	if (locale === "fr") return fr_seller_orders_rental_dates(inputs)
	if (locale === "de") return de_seller_orders_rental_dates(inputs)
	if (locale === "ja") return ja_seller_orders_rental_dates(inputs)
	if (locale === "zh") return zh_seller_orders_rental_dates(inputs)
	if (locale === "ar") return ar_seller_orders_rental_dates(inputs)
	if (locale === "id") return id_seller_orders_rental_dates(inputs)
	if (locale === "it") return it_seller_orders_rental_dates(inputs)
	if (locale === "ru") return ru_seller_orders_rental_dates(inputs)
	if (locale === "pt") return pt_seller_orders_rental_dates(inputs)
	return ko_seller_orders_rental_dates(inputs)
});